<template>
    <div>
        <base-button
            @click="showPersonalizationPolicy"
            class="h-auto lg:underline normal-case text-sm font-light tracking-normal"
        >
            {{ $t('PERSONALIZATION_POLICY') }}
        </base-button>

        <personalization-policy-modal
            @modalClose="showModal = false"
            :show-modal="showModal"
        />
    </div>
</template>

<script>
    import BaseButton from './BaseButton.vue';
    import PersonalizationPolicyModal from './PersonalizationPolicyModal.vue';

    export default {
        components: {
            BaseButton,
            PersonalizationPolicyModal,
        },

        data() {
            return {
                showModal: false,
            };
        },

        methods: {
            showPersonalizationPolicy() {
                this.showModal = true;
            },
        },
    };
</script>
